import React, { Component } from "react";

import EditorLabel from "editor/components/EditorLabel";
import ResetToDefaultProps from "editor/components/ResetToDefaultProps";
import PropsPopover from "editor/components/PropsPopover";
import ShadowBox from "editor/components/EditorElements/ShadowBox";
import SwitchComponent from "editor/components/EditorElements/SwitchComponent/Switch";
import { I18n } from "react-redux-i18n";

import { PropListItem, ActiveLabel, PropLabelFlex } from "../styles";
import {
  AxisInput,
  AxisValuesBox,
  BlurValuesBox,
  BlurWrapper,
  FlexContainer,
  ShadowBoxWrapper,
  ShadowContainer,
  ShadowSwitchWrapper,
  ShadowTypeWrapper,
  TypeButton,
  TypeButtonWrapper,
} from "./styles";
import RangeInput from "../RangeInput";
import ColorPickerComponent from "../ColorPickerComponent";

class Shadow extends Component {
  switchHandler = () => {
    const { name, updaterFn, currentValue } = this.props;
    const { enabled } = currentValue;

    updaterFn({ prop: name, value: { ...currentValue, enabled: !enabled } });
  };

  typeChangeHandler = (type) => {
    const { name, updaterFn, currentValue } = this.props;

    updaterFn({ prop: name, value: { ...currentValue, type } });
  };

  colorChangeHandler = (colorProps) => {
    const { updaterFn, name, currentValue } = this.props;

    updaterFn({
      prop: name,
      value: { ...currentValue, color: colorProps.rgb },
    });
  };

  offsetChangeHandler = ({ x, y }) => {
    const { updaterFn, name, currentValue } = this.props;

    updaterFn({
      prop: name,
      value: {
        ...currentValue,
        horizontal: Math.floor(x),
        vertical: Math.floor(y),
      },
    });
  };

  blurChangeHandler = (e) => {
    const { updaterFn, name, currentValue } = this.props;

    updaterFn({ prop: name, value: { ...currentValue, blur: e.target.value } });
  };

  offsetInputHandler = (e, direction) => {
    const { updaterFn, name, currentValue } = this.props;

    updaterFn({
      prop: name,
      value: { ...currentValue, [direction]: e.target.value },
    });
  };

  render() {
    const {
      label,
      locale,
      tooltip,
      name,
      defaultValue,
      currentValue,
      updaterFn,
    } = this.props;
    const { enabled, type, color, horizontal, vertical, blur } = currentValue;

    const tooltipText = (tooltip && tooltip[locale]) || null;

    return (
      <PropListItem>
        <PropLabelFlex>
          <EditorLabel tooptip={tooltipText}>{label[locale]}</EditorLabel>
          <ActiveLabel active={enabled}>{I18n.t(enabled ? 'editPanel.active' : 'editPanel.disabled')}</ActiveLabel>
        </PropLabelFlex>
        <FlexContainer>
          <ResetToDefaultProps
            name={name}
            defaultProps={defaultValue}
            updaterFn={updaterFn}
          />
          <PropsPopover>
            <ShadowContainer>
              <ShadowSwitchWrapper>
                <span>{I18n.t("editPanel.shadow.enableShadow")}</span>
                <SwitchComponent value={enabled} onClick={this.switchHandler} />
              </ShadowSwitchWrapper>
              {type && (
                <ShadowTypeWrapper>
                <span>{I18n.t("editPanel.shadow.type")}</span>
                <TypeButtonWrapper>
                  <TypeButton
                    active={type === "external"}
                    onClick={() => this.typeChangeHandler("external")}
                  >
                    {I18n.t("editPanel.shadow.outside")}
                  </TypeButton>
                  <TypeButton
                    active={type === "internal"}
                    onClick={() => this.typeChangeHandler("internal")}
                  >
                    {I18n.t("editPanel.shadow.inside")}
                  </TypeButton>
                </TypeButtonWrapper>
                </ShadowTypeWrapper>
              )}
              <ColorPickerComponent 
                color={color}
                onChange={this.colorChangeHandler}
                label={
                  <EditorLabel tooltip={tooltipText}>
                    {I18n.t("editPanel.shadow.color")}
                  </EditorLabel>
                }
                labelFontSize={13}
                labelGap={17}
              />
              <ShadowBoxWrapper>
                <AxisValuesBox>
                  <div>
                    {I18n.t("editPanel.shadow.horizontal")}
                    <AxisInput
                      type="number"
                      min={-25}
                      max={25}
                      step={1}
                      value={horizontal}
                      onChange={(e) => this.offsetInputHandler(e, "horizontal")}
                    />
                  </div>
                  <div>
                    {I18n.t("editPanel.shadow.vertical")}
                    <AxisInput
                      type="number"
                      min={-25}
                      max={25}
                      step={1}
                      value={vertical}
                      onChange={(e) => this.offsetInputHandler(e, "vertical")}
                    />
                  </div>
                </AxisValuesBox>
                <ShadowBox
                  width={60}
                  height={60}
                  initialX={horizontal}
                  initialY={vertical}
                  circleRadius={5}
                  color="#44ADF8"
                  onDrag={this.offsetChangeHandler}
                />
              </ShadowBoxWrapper>
              <BlurWrapper>
                <BlurValuesBox>
                {I18n.t("editPanel.shadow.blur")}
                  <AxisInput
                    type="number"
                    min={0}
                    max={100}
                    step={1}
                    value={blur}
                    onChange={this.blurChangeHandler}
                  />
                </BlurValuesBox>
                <div className="slider">
                  <RangeInput
                    min={0}
                    max={100}
                    step={1}
                    value={blur}
                    onChange={this.blurChangeHandler}
                  />
                </div>
              </BlurWrapper>
            </ShadowContainer>
          </PropsPopover>
        </FlexContainer>
      </PropListItem>
    );
  }
}

export default Shadow;
